import { render, staticRenderFns } from "./ToggleEditButton.vue?vue&type=template&id=36e6d993&"
import script from "./ToggleEditButton.vue?vue&type=script&lang=js&"
export * from "./ToggleEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports